import { Icon } from 'components/Icon';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './StoreBackButton.scss';
/**
 * Back to the previous step, shown on the same row as the step title.
 * Labelled on desktop, a round chevron on mobile.
 * @component StoreBackButton
 * @since 1.0.0
 */
export function StoreBackButton(props) {
    const { onPress, disabled = false, onImage = false } = props;
    const className = classNames('store-back-button', props.className, {
        'store-back-button--on-image': onImage
    });
    return (React.createElement("button", { type: "button", className: className, "aria-label": t('Back'), title: t('Back'), disabled: disabled, onClick: onPress },
        React.createElement(Icon, { value: "chevron-left" }),
        React.createElement("span", { className: "store-back-button__label" }, t('Back'))));
}
